module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("cgnpz"))).then(() => parcelRequire('1iHdE'));